export const CHTheme = {
  token: {
    colorPrimary: '#27ae60',
    colorText: 'white',
  },
  components: {
    Select: {
      multipleItemBg: '#e9f7ef',
      colorBgContainer: 'transparent',
      colorBgElevated: 'grey',
      optionSelectedBg: '#27ae60',
    },
    Tree: {
      colorBgContainer: 'transparent',
    },
    Collapse: {
      contentBg: 'transparent',
    },
    Descriptions: {
      labelColor: 'white',
    },
  },
};
